@if (showHeader) {
  <div
    class="bundle-information-header-wrapper"
    data-cy="bundle-information-header-wrapper">
    @if (showExcelButton) {
      <app-tooltip [dynamic]="false" message="Export to excel">
        <button (click)="exportExcel()"
          class="btn-text-link bundle-information-header-export-excel-button"
          data-cy="bundle-information-header-export-excel-button">
          <span class="iwp-icon-gen_export_excel"
          data-cy="bundle-information-header-export-excel-button-icon"></span>
          <span class="text"
          data-cy="bundle-information-header-export-excel-button-label">{{EXPORT_BUNDLE_BUTTON_LABEL}}</span>
        </button>
      </app-tooltip>
    }
    @if (showSentUnsentAndFlyingMenu) {
      <div class="bundle-sent-wrapper" data-cy="bundle-sent-wrapper">
        <app-switch-button
          [switchButtonConfiguration]="sentSwitchButtonConfiguration"
          [switchButtonModel]="switchButtonModel"
          (switch)="toggleSent($event)"
        data-cy="bundle-sent-switch"></app-switch-button>
      </div>
      <div class="bundle-flying-menu-wrapper">
        <div class="bundle-flying-menu" data-cy="bundle-flying-menu">
          <app-tooltip [dynamic]="false" message="{{BUNDLE_FLYING_MENU_TOOLTIP}}">
            <app-flying-menu [isDisable]="!bundleIsMarked">
              <div class="bundle-sent-icon" labelFlyingMenu>
                <span class="iwp-icon-gen_user"></span>
              </div>
              <div class="bundle-sent-detail-content-wrapper" contentFlyingMenu>
                <div class="bundle-sent-detail-label"
                data-cy="bundle-sent-by-detail-label">{{BUNDLE_MARKED_BY_LABEL}}</div>
                <div class="bundle-sent-detail-content"
                data-cy="bundle-sent-by-detail-content">{{bundleSentBy | prettyPrintClosedBy | undefinedValue}}</div>
                <div style="margin-bottom: 24px"></div>
                <div class="bundle-sent-detail-label"
                data-cy="bundle-sent-on-detail-label">{{BUNDLE_MARKED_ON_LABEL}}</div>
                <div class="bundle-sent-detail-content"
                data-cy="bundle-sent-on-detail-content">{{bundleSentOn | undefinedValue}}</div>
              </div>
            </app-flying-menu>
          </app-tooltip>
        </div>
      </div>
    }
  </div>
}

<div class="bundle-information-table-wrapper" data-cy="bundle-information-table-wrapper">
  <div class="bundle-information-table-header-wrapper">
    <app-info-chart [configuration]="bundleTotalAmountInfoChart()"
      (mouseHoverLineTable)="mouseHoverLine($event)"
      [elementClickManually]="$safeNavigationMigration(state?.selectedLine)"
      [elementMouseHover]="state.mouseHoverLineIdentifier"
    (identifier)="openLine($event, true, false)"></app-info-chart>
    <div class="bundle-information-total-wrapper">
      <div class="bundle-information-total-amount-placeholder" data-cy="bundle-information-table-total-amount"></div>
      <div class="bundle-information-table-spec-wrapper" data-cy="bundle-information-table-spec-wrapper">
        <app-card [baseCypressTag]="BUNDLE_CRITERIA_CYPRESS_TAG"
          [listGroups]="bundleCriteriaInfo"
        [title]="BUNDLE_CRITERIA_TITLE"></app-card>
      </div>
    </div>
  </div>
  <div class="bundle-information-title" data-cy="bundle-information-title">Bundle information table</div>
  <app-table (selectedLine)="openLine($safeNavigationMigration($event?.identifier), false, false)"
    (mouseHoverLine)="mouseHoverHandler($event)"
    (mouseleave)="mouseHoverHandler($event)"
    [accordionLineTemplate]="accordionLineTemplate"
    [tableData]="tableData">
  </app-table>

  @if (showClosedInformation) {
    <div
      class="bundle-closed-information-wrapper" data-cy="bundle-closed-information-wrapper">
      <div class="bundle-closed-information-content" data-cy="bundle-closed-information-content">
        <div class="bundle-closed-information-content-label"><span
        data-cy="bundle-closed-information-content-label-closed-by">Closed by</span></div>
        <div class="bundle-closed-information-content-text"
        data-cy="bundle-closed-information-content-text-closed-by">{{bundleClosedBy| prettyPrintClosedBy | undefinedValue}}</div>
      </div>
      <div class="bundle-closed-information-content">
        <div class="bundle-closed-information-content-label"><span
        data-cy="bundle-closed-information-content-label-closed-on">Closed on</span></div>
        <div class="bundle-closed-information-content-text"
        data-cy="bundle-closed-information-content-text-closed-on">{{bundleClosedOn | undefinedValue}}</div>
      </div>
    </div>
  }
</div>


@if (showFooter) {
  <div
    class="bundle-information-footer-wrapper"
    data-cy="bundle-information-footer-wrapper">
    <div class="bundle-information-footer-right-section">
      <button (click)="closeBundleClick()"
        class="btn-primary"
        data-cy="bundle-information-footer-close-bundle-button"
        type="button">Close bundle
      </button>
    </div>
  </div>
}

<ng-template #accordionLineTemplate>
  <app-bundle-settlements-table [currency]="bundleCriteria.currency"
  [settlementsData]="accordionContext"></app-bundle-settlements-table>
</ng-template>

